export default __webpack_public_path__ + "static/media/undo.3ec4177f.svg";